import $axios from '~/plugins/axios';

import { Api, GetPromoCategoryParams, PromoCategory } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetPromoCategoryParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		params: {} as LazyLoadingParams,
		promoCategoryByUuid: {} as Dict<PromoCategory>,
		orderedUuids: [] as string[],
	})
	.withGetters({
		params: state => state.params,
		items: (state) => state.orderedUuids.map(uuid => state.promoCategoryByUuid[uuid]),
		byUuid: (state) => (uuid: string) => state.promoCategoryByUuid[uuid],
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedUuids = [];
		},
		APPEND_PROMO_CATEGORIES (state, categories: PromoCategory[]) {
			state.promoCategoryByUuid = { ...state.promoCategoryByUuid, ...createDict(categories, ({ uuid }) => uuid) };
			state.orderedUuids = Array.from(new Set([ ...state.orderedUuids, ...categories.map((category) => category.uuid) ]));
		},
		SET_PROMO_CATEGORIES (state, categories: PromoCategory[]) {
			state.promoCategoryByUuid = { ...state.promoCategoryByUuid, ...createDict(categories, ({ uuid }) => uuid) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number | null = 20) {
			const params: GetPromoCategoryParams = { ...state.params, limit, offset: state.orderedUuids.length };

			const { data } = await api.get('/promo-category', { params });

			commit('APPEND_PROMO_CATEGORIES', data.payload);
		},
		async prefetchPromoCategories ({ commit }, categories: PromoCategory[]) {
			commit('SET_PROMO_CATEGORIES', categories);
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});
